<template>
    <div class="living">
        <van-nav-bar
                title="Verificación facial"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>

        <div class="living_head">
            <!--<img src="../../assets/img/livingverify_top.png" />-->
            <div class="living_hview">
                <div class="living_hvleft">
                    <img src="../../assets/img/livinghead_icon01.png" />
                </div>
                <div class="living_hvright">
                    Protegemos sus datos privados, que solo se utilizan …
                </div>
            </div>
        </div>

        <div class="living_contview">

            <div class="mainview_itoken_wrap">
                <div class="living_wrap">
                    <div class="living_commer" v-if="uploadimg">
                        <div class="living_commer_imgs">
                            <img class="living_commer_img" :src="uploadimg" alt="">
                            <div class="living_commer_imgerror" v-if="!verfiysucc">
                                <img src="../../assets/img/living_commer_imgerror.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="living_commer" v-else>
                        <div class="img">
                            <!--<div class="img-bg"></div>-->
                            <!--<div class="img-line"></div>-->
                            <img src="../../assets/img/face_tipsnew.gif" alt="">
                        </div>
                    </div>

                </div>

                <div class="living_mdesc" :class="!verfiysucc ? 'living_mdescerr' : ''">
                    <p>
                        Coloque su cara en el marco y no la mueva después de hacer el clic <span>"Inciar la verificación"</span>
                    </p>
                </div>

                <div class="living_mbtns">
                    <div class="living_mbtn" @click="gotoStart">
                        <van-button round color="#19A95C" block style="height: 1.222222rem;">
                            <span style="font-weight: bold;">Tomar foto</span>
                        </van-button>
                    </div>
                </div>
                <div class="living_footer_wrap">
                    <div class="living_footer">
                        <img src="../../assets/img/livingverify_footer.png" alt="">
                    </div>
                </div>
            </div>

        </div>

        <input type="file" accept="image/*" capture="user" ref="videoFile" @change="changeVideo" class="file-input" hidden />


        <van-popup v-model="messageShow" :close-on-click-overlay="false">
            <div class="living_popwrap">
                <div class="living_poptitle">Por favor sigue las instrucciones</div>
                <div class="living_popdesc">Para solicitar un préstamo, debe confirmar que está solicitando en persona y asegurarse de que su dinero no ingrese a las cuentas de otras personas. Así que ahora necesitas hacer una verificación facial.</div>
                <div class="living_popimgs">
                    <img src="../../assets/img/living_popimgs.png" alt="">
                </div>
                <div class="living_popbtns" @click="onClosepop">
                    <van-button round color="#00CA88" block style="height: 40px;">
                          <span style="font-weight: bold; font-size: 16px;">Verificación facial
                              <template v-if="nums > 0">
                                  （{{ verval }}）
                              </template>
                          </span>
                    </van-button>
                </div>
            </div>
        </van-popup>

    </div>
</template>

<script>

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { verifyLive } from '@/api/upload'

    import { getLoanInfo, confirmOrder } from '@/api/loan'

    import Crypto from '@/utils/crypto'

    import { Toast } from 'vant';

    import ImageCompressor from 'js-image-compressor'

    import $ from 'jquery';

    let clock = null;
    export default {
        data() {
            return {
                activeNav: 'living',
                nums: 4,
                verval: '',
                messageShow: true,
                uploadimg: null,
                verfiysucc: true,
            }
        },
        mounted() {
            this.livingVer();
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            doLoop() {
                this.nums--;
                if(this.nums > 0){
                    this.verval = this.nums + 's';
                } else {
                    clearInterval(clock);
                    this.verval = '';
                    this.nums = 0;
                }
            },
            livingVer() {
                let _this = this;
                this.verval = this.nums + 's';
                clock = setInterval(_this.doLoop, 1000);
            },
            onClosepop() {
                this.messageShow = false;
            },
            gotoStart() {
                this.uploadimg = null;
                this.verfiysucc = true;
                this.$refs.videoFile.value = null;
                this.$refs.videoFile.dispatchEvent(new MouseEvent('click'));
            },
            changeVideo() {
                console.log('活体检测')
                let that = this;
                const files = that.$refs.videoFile.files;

                if (files && files.length > 0) {
                    let file = files[0];

                    console.log(file)

                    if (file.type.indexOf("image/") == -1) {
                        Toast("Formato de foto incorrecto"); //照片格式错误
                        return;
                    }

                    // TODO:压缩视频
                    if (file.size > 10 * 1024 * 1024) {
                        Toast('Tamaño de foto excedido por favor tome otra foto'); //照片大小超限，超出 10 MB,请重新录制
                        return;
                    }
                    /*Toast.loading({
                        message: '上传中...',
                        duration: 0,
                        forbidClick: true
                    });*/
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        let result = reader.result;
                        //that.faceReco(result, file.size)
                        console.log(file)
                        that.compressionImage(file, result)
                        console.log(file.size)
                        //that.faceReco(file, file.size, result)
                        /*let img = new Image();
                        img.src = reader.result;
                        img.onload = () => {
                            let originWidth = img.naturalWidth,
                                originHeight = img.naturalHeight,
                                originSize = file.size;
                            this.compressEvent(img, originSize, originWidth, originHeight);
                        };*/
                    }
                }
            },
            dataURItoBlob(dataURI) {
                // base64格式转化为blob对象
                let byteString = atob(dataURI.split(",")[1]);

                let mimeString = dataURI
                    .split(",")[0]
                    .split(":")[1]
                    .split(";")[0];

                let ab = new ArrayBuffer(byteString.length);
                let ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                return new Blob([ab], { type: mimeString });
            },
            compressionImage (file, base64img) {
                let _this = this;
                return new Promise((resolve, reject) => {
                    // eslint-disable-next-line no-new
                    new ImageCompressor({
                        file: file,
                        quality: 0.8,
                        maxWidth: 1500,
                        maxHeight: 1500,
                        redressOrientation: false,

                        // 压缩前回调
                        beforeCompress: function (result) {
                            console.log(result)
                            console.log('压缩之前图片尺寸大小: ', result.size)
                            console.log('mime 类型: ', result.type)
                        },

                        success: function (result) {
                            console.log(result)
                            console.log('压缩之后图片尺寸大小: ', result.size)
                            console.log('mime 类型: ', result.type)
                            console.log('实际压缩率： ', ((file.size - result.size) / file.size * 100).toFixed(2) + '%')

                            _this.faceReco(result, result.size, base64img)
                            resolve(result)
                        },
                        error (e) {
                            reject(e)
                        }
                    })
                })
            },
            faceReco(result, fileSize, base64img){
                let _this = this;
                /*Toast.loading({
                    message: 'Bajo verificación...', //验证中
                    duration: 0,
                    forbidClick: true
                });*/

                this.getCommomParams(result, fileSize, base64img)

                //模拟调用风控sdk
                setTimeout(() => {
                    //验证成功
                    //Toast.clear();

                    _this.verfiysucc = true;

                    _this.uploadimg = base64img;

                }, 200)
            },
            onCheckTokenKey() {
                let tokenKey = this.$store.state.common.tokenKey;

                if(tokenKey && tokenKey.length > 0){
                    this.onConfirmOrder(tokenKey);
                } else {
                    let _this = this;
                    setTimeout(() => {
                        client.record("login").then((r) => {
                            console.log(r);
                            //localStorage.setItem("tokenKey", r);
                            _this.$store.commit('common/SET_TOKEN_KEY', r);
                            _this.onConfirmOrder(r);
                        });
                    }, 10);
                }
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }

                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            async onConfirmOrder(tokenKey) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        vjk_fjt_bvh: tokenKey,
                        bpb_imu_jqa: '',
                        fkc_cmc_zbn: '',
                        doe_ody_zty: '',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    confirmOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    let { bqr_rle_jto } = useDataJSON;

                                    if(bqr_rle_jto == 8001){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/applywork'
                                        })
                                    } else if(bqr_rle_jto == 8002){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/applycontacts'
                                        })
                                    } else if(bqr_rle_jto == 8004){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/applyperson'
                                        })
                                    } else if(bqr_rle_jto == 8005){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/applyidcard'
                                        })
                                    } else if(bqr_rle_jto == 8006){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/livingverify'
                                        })
                                    } else if(bqr_rle_jto == 7106){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/livingverify'
                                        })
                                    } else if(bqr_rle_jto == 8010){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/applybank'
                                        })
                                    } else if(bqr_rle_jto == 7105){
                                        loadingHide()
                                        this.$router.replace({
                                            path: '/loanpage/reapeatloan'
                                        })
                                    } else if(bqr_rle_jto == 7109){
                                        this.gotoStatus()
                                        // this.$router.replace({
                                        //     path: '/loanpage/applyhome'
                                        // })
                                    } else if(bqr_rle_jto == 7101){
                                        this.gotoStatus()
                                        // this.$router.replace({
                                        //     path: '/loanpage/applyhome'
                                        // })
                                    } else if(bqr_rle_jto == 7102){
                                        this.gotoStatus()
                                        // this.$router.replace({
                                        //     path: '/loanpage/applyhome'
                                        // })
                                    } else if(bqr_rle_jto == 7105){
                                        this.gotoStatus()
                                        // this.$router.replace({
                                        //     path: '/loanpage/applyhome'
                                        // })
                                    } else if(bqr_rle_jto == 8110){
                                        this.gotoStatus()
                                        // this.$router.replace({
                                        //     path: '/loanpage/applyhome'
                                        // })
                                    }
                                }
                            }
                        } else {
                            loadingHide()
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async getCommomParams(result, fileSize, base64img) {
                let _this = this;
                let timezoneName = getTimezoneName(); //时区
                loadingShow();
                let ip = await getUserIp();
                let commonParams = _this.commonParams(timezoneName, ip, result, fileSize, base64img)
            },
            commonParams(time_zone, ip, result, fileSize, base64img) {
                let access_token = getAccessToken();
                let forms = new FormData();
                forms.append('zzm_yya_hqb', access_token);
                forms.append('aaa_off_csl', '111');
                forms.append('foi_nnk_qbi', '0');
                forms.append('fs1', result);
                forms.append('ppg_dog_zej', fileSize);

                let currentTime = new Date().getTime();
                let secretClient = 'oewioewgoijpghrporeghpwueoreloikweiokeweekqqierijfd';
                let cipherStr = Crypto.encrypt(currentTime + "#" + secretClient, secretClient);

                console.log('客户端密钥:' + secretClient);
                console.log('客户端时间戳:' + currentTime);
                console.log('客户端密文:' + cipherStr);

                forms.append('ckn_emo_hfg', currentTime);

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                verifyLive(forms, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    'egewg-key': 'rigewjgewgewhiofee',
                    'x-timestamp': currentTime,
                    'x-ciphertext': cipherStr,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    Toast.clear()
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if(useData){
                            let useDataJSON = JSON.parse(useData);
                            let { hla_mvv_jhu } = useDataJSON;

                            if(hla_mvv_jhu){
                                let isreloan = this.getQueryString('isreloan');

                                if(isreloan && isreloan == 1){
                                    loadingHide()
                                    this.$router.replace({
                                        path: '/loanpage/reapeatloan'
                                    });
                                } else {
                                    this.onCheckTokenKey();
                                }
                            } else {
                                loadingHide()
                                Toast('La verificación en vivo falló, por favor vuelva a intentarlo')
                            }
                        }
                    } else {
                        loadingHide()
                        //Toast(res.ms);
                        Toast('La verificación en vivo falló, por favor vuelva a intentarlo')
                    }
                }, error => {
                    loadingHide()
                    Toast.clear()
                })
            },
        }
    }
</script>

<style less scoped>
    .living_wrap{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 1.055556rem 0 0 0;
    }
    .living_commer{
        width: 5.166667rem;
        height: 5.166667rem;
        margin: 0 auto;
    }

    .living_commer .img {
        position: relative;
        margin: 0 auto;
        width: 5.166667rem;
        height: 5.166667rem;
    }
    @keyframes bgmove {
        from {
            height: 0;
        }
        to {
            height: 4.47rem;
        }
    }
    .living_commer .img-bg,
    .living_commer .img-line {
        position: absolute;
        top: 0.361111rem;
        left: 0.361111rem;
        width: 4.47rem;
        overflow: hidden;
    }
    .living_commer .img-bg {
        animation: bgmove 4s linear infinite;
        animation-direction: alternate;
        z-index: 1;
    }
    .living_commer .img-bg:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4.47rem;
        height: 4.47rem;
        background: linear-gradient(0deg, transparent 0%, rgba(104, 24, 133, .3) 50%, transparent 100%);
        border-radius: 50%;
    }
    .living_commer .img-line {
        z-index: 6;
        height: 4.47rem;
        border-radius: 50%;
    }
    .living_commer .img-line:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        border-bottom: 2px solid #2b6814;
        animation: bgmove 4s linear infinite;
        animation-direction: alternate;
    }
    .living_commer .img img {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 2;
    }
    .living_mdesc{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.444444rem 0.833333rem 0.305556rem 0.833333rem;
    }
    .living_mdesc p{
        width: 100%;
        font-size: 0.388889rem;
        font-family: Roboto-Regular, Roboto;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.5rem;
        text-align: center;
    }
    .living_mdesc p span{
        color: #00CA88;
    }
    .living_mbtns{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 0.444444rem 0.416667rem 0.444444rem;
    }
    .living_mbtn{
        width: 100%;
        height: auto;
    }
    .living_mbtn span{
        font-size: 0.42rem;
        font-weight: 500;
    }
    .living_footer_wrap{
        width: 100%;
        height: auto;
        padding-bottom: 0.555556rem;
    }
    .living_footer{
        width: 91.11%;
        height: auto;
        margin: 0 auto;
    }
    .living_footer img{
        display: block;
        width: 100%;
    }
    .living_commer_imgs{
        width: 5.166667rem;
        height: 5.166667rem;
        position: relative;
    }
    .living_commer_img{
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 0.555556rem;
    }
    .living_commer_imgerror{
        width: 1.222222rem;
        height: 1.222222rem;
        position: absolute;
        right: -0.416667rem;
        bottom: -0.416667rem;
    }
    .living_commer_imgerror img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .living_mdescerr p{
        color: #DB861F;
    }
    .living_mdescerr p span{
        color: #DB861F;
    }
    .living .van-popup{
        background: rgba(255, 255, 255, 0);
    }
    .living_popwrap{
        width: 80.56vw;
        height: auto;
        background: #ffffff;
        border-radius: 0.555556rem;
        box-sizing: border-box;
        padding: 0.694444rem 0.555556rem 0.555556rem 0.555556rem;
    }
    .living_poptitle{
        width: 100%;
        height: 1.0rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.444444rem;
        text-align: center;
    }
    .living_popdesc{
        width: 100%;
        height: auto;
        padding-bottom: 0.555556rem;
        font-size: 12px;
        font-weight: 400;
        color: #808080;
        line-height: 14px;
    }
    .living_popimgs{
        width: 100%;
        height: auto;
        padding-bottom: 0.555556rem;
    }
    .living_popimgs img{
        display: block;
        width: 100%;
        height: 2.055556rem;
    }
    .living_popbtns{
        width: 100%;
        height: 1.222222rem;
    }
    .living_head{
        width: 100%;
        height: 1.45rem;
        box-sizing: border-box;
        padding: 0.25rem 0.277778rem 0 0.277778rem;
        position: relative;
    }
    .living_hview{
        width: 100%;
        height: 0.694444rem;
        position: absolute;
        left: 0;
        bottom: 0.25rem;
        background: #DDF2E7;
        box-sizing: border-box;
        padding-left: 0.555556rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .living_contview{
        width: 89.03%;
        background: #FFFFFF;
        box-shadow: 0px 2px 0.138889rem 0px rgba(0,0,0,0.19);
        border-radius: 0.222222rem;
        margin: 0 auto;
    }
    .living_hvleft{
        width: 0.555556rem;
        height: 0.611111rem;
    }
    .living_hvleft img{
        display: block;
        width: 0.555556rem;
        height: 0.611111rem;
    }
    .living_hvright{
        width: 7.972222rem;
        height: 0.416667rem;
        margin-left: 0.222222rem;
        font-size: 12px;
        font-weight: 500;
        color: #19A95C;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
</style>

